define('ch_semantic_responsive',[
    'jquery',
    'semantic',
], function ($) {
    var $sidebar;
    var $sidebarToggleBtn;
    var $mobileDimmer;
    var $mobileTogglers;

    var showSidebar = function () {
        $mobileDimmer.dimmer('show');
        $sidebar.sidebar('show');
    };

    var hideSidebar = function () {
        $mobileDimmer.dimmer('hide');
        $sidebar.sidebar('hide');
    };

    /**
     * tbh I don't know what this function is doing...
     */
    var toggleSidebar = function () {
        var $this = $(this);
        var $target = $('#' + $this.data('target')); // get target via id on data-target
        var isActive = $this.hasClass('active');

        $mobileDimmer.dimmer('show');
        $sidebar.sidebar('hide');

        // open up this menu if it is not already open
        if (!isActive) {
            // Show the currently active item
            $this.addClass('active');
            $target.slideDown();

            // show dimmer
            $mobileDimmer.dimmer('setting', {
                closable: true,
                onHide: function () {
                    $this.removeClass('active');
                    $target.slideUp();
                },
            }).dimmer('show');

            // hack to fix buggy behavior from sidebar https://github.com/Semantic-Org/Semantic-UI/issues/2087
            $('.pusher.dimmed').removeClass('dimmed dimmable');
            $mobileDimmer.on('click', function () {
                $mobileDimmer.dimmer('toggle'); // somehow this is required to fix the bug
                $mobileDimmer.dimmer('hide');
                $mobileDimmer.unbind('click');
            });
        } else {
            $mobileDimmer.dimmer('hide');
        }
    };

    function initSidebar() {
        $sidebar = $('#mobile-sidebar');
        $sidebarToggleBtn = $('#js-sidebar-toggle');
        $mobileDimmer = $('#mobile-dimmer');
        $mobileTogglers = $('.js-mobile-toggle');

        $sidebar.sidebar('setting', {
            delaySetup: true,
            onHide: function () {
                $mobileDimmer.dimmer('hide');
            },
            onHidden: function () {
                $sidebarToggleBtn.one('click', showSidebar);
            },
        });

        // we'll add a one-time handler so that it opens the sidebar on click
        // but will not interfere with default sidebar "closing" behavior, handled by the sidebar
        // it is later added back once sidebar is hidden
        $sidebarToggleBtn.one('click', function (e) {
            e.preventDefault();
            showSidebar.call(this);
        });

        $mobileTogglers.on('click', function (e) {
            e.preventDefault();
            toggleSidebar.call(this);
        });
    }

    $(function () {
        if (CH && CH.isMobile) {
            initSidebar();
        }
    });

    // exposing these so users of the responsive lib can hide/show the dimmer on demand
    return {
        hideSidebar,
        showSidebar,
    };
});

